<template>
	<v-overlay :value="loading" :dark="false" z-index="9999">
		<v-card max-width="200px">
			<v-card-text class="d-flex justify-center">
				<v-progress-circular :size="25" indeterminate color="primary" />
				<span class="mx-3 text-button">Loading</span>
			</v-card-text>
		</v-card>
	</v-overlay>
</template>

<script>
import { mapGetters } from 'vuex';
import { GeneralGetters } from '@/store/getters';
export default {
	name: 'LoadingOverlay',
	computed: {
		...mapGetters({
			loading: [GeneralGetters.IS_LOADING],
		}),
	},
};
</script>
